import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import DataTableToolbar from '../../_Shared/DataTables/DataToolbar';
import DataTable from '../../_Shared/DataTables/DataTable';
import CreateModal from '../../_Shared/CreateModal';
import AppContent from '../../_Shared/Layout/AppContent';

const _ = require('lodash');

class FormatList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            formatName: '',
            showModal: false,
            anchorEl: null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.props.onActivate();
    }

    componentDidUpdate(prevProps, prevState) {
        const { website } = this.props;
        if (website !== null && !_.isEqual(prevProps.website, website)) {
            this.setState({ website });
        }
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    toggleCreateModal = e => {
        const { showModal } = this.state;
        this.setState({ showModal: !showModal, formatName: '', isUpdate: false });
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleEditModal = e => {
        const { formatName, showModal } = this.state;
        this.setState({ showModal: !showModal, anchorEl: null, formatName: formatName, isUpdate: true });
    }

    handleInputChange = formatName => this.setState({ formatName })

    selectElement = (format, index) => {
        this.setState({ formatName: format.name, selectedIndex: index });
    }

    createOrUpdateFormat = e => {
        const { website, onWebsiteUpdated } = this.props;
        const { formatName, isUpdate, selectedIndex } = this.state;
        if (!isUpdate) {
            onWebsiteUpdated(Object.assign({}, website, { formats: [...website.formats, formatName] }), 'add_format');
        } else {
            let aux = Object.assign([], website.formats);
            aux.splice(selectedIndex, 1, formatName);            
            onWebsiteUpdated(Object.assign({}, website, { formats: aux }), 'update_format');
        }
        this.toggleCreateModal(e);
        this.setState({ formatName: '' });
    }

    deleteFormat = () => {
        const { website, onWebsiteUpdated } = this.props;
        const { formatName } = this.state;
        onWebsiteUpdated(Object.assign({}, website, { formats: website.formats.filter(x => x !== formatName) }), 'delete_format');
        this.setState({ formatName: '', anchorEl: null });
    }

    render() {
        const { website, loading } = this.props;
        const { showModal, formatName, anchorEl } = this.state;
        return (<AppContent>
            {
                loading && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Formats" numSelected={0} >
                <Tooltip title="Add New">
                    <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                </Tooltip>
            </DataTableToolbar>
            {
                website && website.formats &&
                <DataTable columns={[{ label: 'Name', field: 'name' }]} anchorEl={anchorEl} rows={website.formats.map(x => ({ name: x }))}
                    toggleRowMenu={this.toggleRowMenu} onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu}>
                    <MenuItem onClick={this.toggleEditModal}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteFormat}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            <CreateModal title="Create/Edit Format" open={showModal} closeHandler={this.toggleCreateModal} saveHandler={this.createOrUpdateFormat}>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        <TextField autoFocus value={formatName} onChange={e => this.handleInputChange(e.target.value)} id="formatName" name="formatName" label="Format Name" type="text" fullWidth />
                    </Grid>
                </Grid>
            </CreateModal>
        </AppContent>)
    }
}

FormatList.propTypes = {
    website: PropTypes.object.isRequired,
};

export default FormatList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Websites/Formats/FormatList.js